import GraphQL from '@app/model/_common/service/GraphQL';
import {
	ALERT_EXECUTION_FRAGMENT,
	ALERT_OUTPUT_FRAGMENT,
	COMPETITORS_SOLD_OUT_ALERT_EXECUTION_NOTIFICATION,
	PARITY_PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATION,
	PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATION,
} from '@app/model/alert/service/AlertGraphQLFragments';
import { MARKET_STATE_DAILY_SNAPSHOT_FRAGMENT } from '@app/model/market_state/service/MarketStateGraphQLFragments';
import { gql } from 'graphql-request';


export const SAVE_ALERT_MUTATION: GraphQL = {
    name: "saveAlert",
    gql: gql`
        ${ALERT_OUTPUT_FRAGMENT}
        mutation saveAlert($input: AlertInput!) {
            saveAlert(input:$input) {
                ...AlertOutputFields
            }
        }
    `
}

export const REMOVE_ALERT_MUTATION: GraphQL = {
    name: "removeAlert",
    gql: gql`
        ${ALERT_OUTPUT_FRAGMENT}
        mutation removeAlert($companyHotelId: Long!, $alertId: Long!) {
            removeAlert(companyHotelId:$companyHotelId, alertId: $alertId) {
                ...AlertOutputFields
            }
        }
    `
}
export const FIND_COMPANY_HOTEL_ALERTS_QUERY: GraphQL = {
    name: "findCompanyHotelAlerts",
    gql: gql`
        ${ALERT_OUTPUT_FRAGMENT}
        query findCompanyHotelAlerts($companyHotelId: Long!) {
            findCompanyHotelAlerts(companyHotelId: $companyHotelId) {
                ...AlertOutputFields
            }
        }
    `
}

export const FIND_ALERT_BY_ID_QUERY: GraphQL = {
    name: "findAlertById",
    gql: gql`
        ${ALERT_OUTPUT_FRAGMENT}
        query findAlertById($companyHotelId: Long!, $alertId: Long!) {
            findAlertById(companyHotelId: $companyHotelId, alertId:$alertId) {
                ...AlertOutputFields
            }
        }
    `
}

export const FIND_ALERT_EXECUTION_BY_ID_QUERY: GraphQL = {
    name: "findAlertExecutionById",
    gql: gql`
        ${ALERT_EXECUTION_FRAGMENT}
        query findAlertExecutionById($companyHotelId: Long!, $alertExecutionId: Long!) {
            findAlertExecutionById(companyHotelId: $companyHotelId, alertExecutionId:$alertExecutionId) {
                ...AlertExecutionFields
            }
        }
    `
}

export const FIND_SUCCESSFUL_ALERT_EXECUTIONS_QUERY: GraphQL = {
    name: "findSuccessfulAlertExecutionsByAlertId",
    gql: gql`
        ${ALERT_EXECUTION_FRAGMENT}
        query findSuccessfulAlertExecutionsByAlertId($companyHotelId: Long!, $alertId: Long!) {
            findSuccessfulAlertExecutionsByAlertId(companyHotelId: $companyHotelId, alertId:$alertId) {
                ...AlertExecutionFields
            }
        }
    `
}

export const FIND_ALERT_NOTIFICATION_MARKET_STATE_QUERY: GraphQL = {
    name: "findAlertNotificationMarketState",
    gql: gql`
        ${MARKET_STATE_DAILY_SNAPSHOT_FRAGMENT}
        query findAlertNotificationMarketState($companyHotelId: Long!, $alertId: Long!, $marketStateId: Long!) {
            findAlertNotificationMarketState(companyHotelId: $companyHotelId, alertId:$alertId, marketStateId:$marketStateId) {
                ...MarketStateDailySnapshotFields
            }
        }
    `
}

export const FIND_PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATIONS_QUERY: GraphQL = {
    name: "findExecutionPriceComparisonNotifications",
    gql: gql`
        ${PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATION}
        query findExecutionPriceComparisonNotifications($companyHotelId: Long!, $alertExecutionId: Long!) {
            findExecutionPriceComparisonNotifications(companyHotelId: $companyHotelId, alertExecutionId: $alertExecutionId) {
                current {
                    ...PriceComparisonAlertExecutionNotificationFields
                }
                previous {
                    ...PriceComparisonAlertExecutionNotificationFields
                }
                currentRate
                previousRate
                isUpdated
                isNew
            }
        }
    `
}

export const FIND_PARITY_PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATIONS_QUERY: GraphQL = {
    name: "findExecutionParityPriceComparisonNotifications",
    gql: gql`
        ${PARITY_PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATION}
        query findExecutionParityPriceComparisonNotifications($companyHotelId: Long!, $alertExecutionId: Long!) {
            findExecutionParityPriceComparisonNotifications(companyHotelId: $companyHotelId, alertExecutionId: $alertExecutionId) {
                current {
                    ...ParityPriceComparisonAlertExecutionNotificationFields
                }
                
            }
        }
    `
}

export const FIND_COMPETITORS_SOLD_OUT_ALERT_EXECUTION_NOTIFICATIONS_QUERY: GraphQL = {
    name: "findExecutionCompetitorsSoldOutNotifications",
    gql: gql`
        ${COMPETITORS_SOLD_OUT_ALERT_EXECUTION_NOTIFICATION}
        query findExecutionCompetitorsSoldOutNotifications($companyHotelId: Long!, $alertExecutionId: Long!) {
            findExecutionCompetitorsSoldOutNotifications(companyHotelId: $companyHotelId, alertExecutionId: $alertExecutionId) {
                current {
                    ...CompetitorsSoldOutAlertExecutionNotificationFields
                }
                
            }
        }
    `
}

export const FIND_COMPETITORS_PRICE_RATE_ALERT_EXECUTION_NOTIFICATIONS_QUERY: GraphQL = {
    name: "findExecutionCompetitorsPriceRateNotifications",
    gql: gql`
        query findExecutionCompetitorsPriceRateNotifications($companyHotelId: Long!, $alertExecutionId: Long!) {
            findExecutionCompetitorsPriceRateNotifications(companyHotelId: $companyHotelId, alertExecutionId: $alertExecutionId) {
                notificationId
                companyHotelId
                alertId
                alertExecutionId
                statDate
                average
                competitorPriceRateChanges {
                    competitorId
                    current {
                        competitorId
                        fromRoomName
                        fromRoomType
                        toRoomName
                        toRoomType
                        rate
                        from
                        to
                    }
                    previous {
                        competitorId
                        fromRoomName
                        fromRoomType
                        toRoomName
                        toRoomType
                        rate
                        from
                        to
                    }
                    isUpdated
                    isNew
                }
                hasAnyNew
                hasAnyUpdated

            }
        }
    `
}